import {
  CreateEventActionConfigForm,
  EventActionConfig,
  UpdateEventActionConfigForm,
  EventActionEvent
} from "@closerplatform/spinner-openapi";
import { FieldState, FormState } from "formstate";
import {
  getLanguageOptionWithDefault,
  LanguageOption
} from "@fidget/common/components/form/languagePicker/languagePicker";
import { validateRequired } from "@fidget/common/utils/validatorsFormState";
import {
  ExistingActionFormFields,
  ExistingActionFormType,
  NewActionFormFields,
  NewActionFormType
} from "./types";

export const mapFormToUpdateForm = (form: ExistingActionFormType): UpdateEventActionConfigForm => {
  return {
    event: form.$.event.$ as EventActionEvent,
    enabled: form.$.enabled.$,
    response: form.$.response.$,
    tagGroupId: form.$.tagGroupId.$ ? form.$.tagGroupId.$ : undefined,
    widgetId: form.$.widgetId.$ ? form.$.widgetId.$ : undefined,
    widgetBlockInput: form.$.widgetBlockInput.$ ? form.$.widgetBlockInput.$ : undefined
  };
};

export const mapFormToCreateForm = (
  form: NewActionFormType,
  locale: LanguageOption
): CreateEventActionConfigForm => {
  if (!form.$.event.$) {
    throw Error("Cannot create event action with no event");
  }

  return {
    locale,
    enabled: true,
    event: form.$.event.$ as EventActionEvent,
    response: form.$.response.$,
    tagGroupId: form.$.tagGroupId.$ ? form.$.tagGroupId.$ : undefined,
    widgetId: form.$.widgetId.$ ? form.$.widgetId.$ : undefined,
    widgetBlockInput: form.$.widgetBlockInput.$ ? form.$.widgetBlockInput.$ : undefined
  };
};

export const mapEventActionToForm = (config: EventActionConfig): ExistingActionFormType => {
  return new FormState<ExistingActionFormFields>({
    id: new FieldState(config.id),
    response: new FieldState(config.response),
    enabled: new FieldState(config.enabled),
    tagGroupId: new FieldState(config.tagGroupId || ""),
    locale: new FieldState<string>(getLanguageOptionWithDefault(config.locale)),
    event: new FieldState(config.event as EventActionEvent),
    widgetId: new FieldState(config.widgetId),
    widgetBlockInput: new FieldState(config.widgetBlockInput || false)
  });
};

export const createNewEventActionForm = (): NewActionFormType => {
  return new FormState<NewActionFormFields>({
    response: new FieldState("").validators(validateRequired),
    event: new FieldState<EventActionEvent | "">("").validators(validateRequired),
    tagGroupId: new FieldState(""),
    widgetId: new FieldState<string | undefined>(undefined),
    widgetBlockInput: new FieldState<boolean>(false)
  });
};

export const copyExistingEventActionForm = (
  form: ExistingActionFormType
): ExistingActionFormType => {
  return new FormState<ExistingActionFormFields>({
    id: form.$.id,
    response: new FieldState(form.$.response.$),
    tagGroupId: new FieldState(form.$.tagGroupId.$),
    event: new FieldState(form.$.event.$),
    enabled: new FieldState(form.$.enabled.$),
    locale: form.$.locale,
    widgetId: new FieldState(form.$.widgetId.$),
    widgetBlockInput: new FieldState(form.$.widgetBlockInput.$)
  });
};
